/* eslint-disable @typescript-eslint/no-explicit-any */
export const swapArrayElements = (theArray: Array<any>, indexA: number, indexB: number): any[] => {
  const arr = [...theArray]
  const temp = arr[indexA]
  arr[indexA] = { ...arr[indexB] }
  arr[indexB] = temp
  return arr
}
